import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
    blockUi: {
        position: 'absolute',
        top: '8px',
        right: '9px',
    },
    marquee: {
        width: '100%',
        height: '100%',
        '& div': {
            overflow: 'hidden',
        },
    },
    notConfigured: {
        height: '95%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        fontSize: theme.typography.size.l,
        fontWeight: theme.typography.fontWeightRegular,
    },
    notConfiguredIcon: {
        '& img': {
            height: theme.spacing(5),
        },
    },
    root: {
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '3.5rem',
        fontWeight: theme.typography.fontWeightRegular,
    },
    tickerRow: {
        display: 'flex',
        flexDirection: 'row',
        cursor: 'pointer',
    },
    unauthorized: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        fontSize: 'large',
        fontWeight: theme.typography.fontWeightBold,
        height: '100%',
    },
    error: {
        height: 'fit-content',
    },
}));
